import type { FunctionComponent, ReactNode } from 'react';

import { Button } from '@dr.pogodin/react-utils';

import type { ModalityT, VideoT } from 'utils';

import IconCross from 'assets/images/icon-cross-16px.svg';
import IconBreathwork from 'assets/images/icon-profile-breathwork.svg';
import IconCallistenic from 'assets/images/icon-profile-callistenic.svg';
import IconFunctional from 'assets/images/icon-profile-functional.svg';
import IconMeditation from 'assets/images/icon-profile-meditation.svg';
import IconOther from 'assets/images/icon-profile-other.svg';
import IconPilates from 'assets/images/icon-profile-pilates.svg';
import IconSomatic from 'assets/images/icon-profile-somatic.svg';
import IconSoundbath from 'assets/images/icon-profile-soundbath.svg';
import IconTaichi from 'assets/images/icon-profile-taichi.svg';
import IconYoga from 'assets/images/icon-profile-yoga.svg';

import infoButtonTheme from 'themes/Button/info-icon-button-grey-40px.scss';

import './style.scss';

function getModalityIcon(modality: ModalityT): ReactNode {
  switch (modality) {
    case 'Breathwork': return <IconBreathwork />;
    case 'Calisthenics': return <IconCallistenic />;
    case 'Functional Movement': return <IconFunctional />;
    case 'Meditation': return <IconMeditation />;
    case 'Other': return <IconOther />;
    case 'Pilates': return <IconPilates />;
    case 'QiGong/Tai Chi': return <IconTaichi />;
    case 'Somatic Movement': return <IconSomatic />;
    case 'Soundbath': return <IconSoundbath />;
    case 'Yoga': return <IconYoga />;
    default: return null;
  }
}

type PropsT = {
  onClose: () => void;
  video: VideoT;
};

export const Info: FunctionComponent<PropsT> = ({ onClose, video }) => {
  const tags: ReactNode[] = video.modalities.map((modality) => (
    <div key={modality} styleName="tag">
      {getModalityIcon(modality)}
      {modality}
    </div>
  ));

  if (video.customModalities) {
    for (const modality of video.customModalities) {
      tags.push(<div key={modality} styleName="tag">{modality}</div>);
    }
  }

  return (
    <div styleName="container">
      <div styleName="header">
        <h1 styleName="title">{video.title ?? 'Untitled'}</h1>
        <Button onClick={onClose} theme={infoButtonTheme}>
          <IconCross fill="white" />
        </Button>
      </div>
      {tags.length ? <div styleName="tags">{tags}</div> : null}
      <div styleName="content">
        {video.userSummary}
      </div>
    </div>
  );
};
